/* global Word */

export interface ListLevelState {
  listType: string | undefined;
  lastNumber: number | undefined;
  listId?: number;
}

export interface ParseState {
  createdElements: { paragraph: Word.Paragraph; originalIndex: number }[];
  frontendBaseUrl?: string;
  listState: Record<number, ListLevelState>;
}

export interface DocumentContent {
  content?: string;
  format: ("bold" | "italic" | "underline" | "strikethrough" | "link" | "code" | "superscript" | "subscript")[];
  href?: string;
  level: number;
}

export interface DocumentElement {
  type: string;
  content: (DocumentElement | DocumentContent)[];
  prefix?: string;
  tabs?: number;
  list_type?: string;
  heading_level?: number;
  word_element_index?: number;
}

// Interface for the actual change structure used by the Word add-in
export interface CanvasChange {
  op: "=" | "~" | "-" | "+";
  e1?: DocumentElement | DocumentContent | string | null;
  e2?: DocumentElement | DocumentContent | string | null;
  old_index: number;
  new_index: number;
  child_changes?: Array<CanvasChange>;
  old_word_index?: number;
}

export function isDocumentElement(el: DocumentElement | DocumentContent | string): el is DocumentElement {
  if (typeof el === "string") return false;
  return "type" in el;
}

export function getType(
  el: DocumentElement | DocumentContent | string
): "documentElement" | "documentContent" | "string" {
  if (typeof el === "string") return "string";
  if (isDocumentElement(el)) return "documentElement";
  return "documentContent";
}

export function isCommentContentRange(
  el: Word.Paragraph | Word.CommentContentRange | Word.Range
): el is Word.CommentContentRange {
  return (el as Word.Paragraph).parentBody === undefined;
}
